import SMConst from 'lib/SMConst';

class SMRoomExceptionHelper {
  static isDailyPrice(exception, plan){
    if (plan.has_session_price && exception.has_session_change_price ||
        !plan.has_session_price && exception.has_daily_change_price) {
      return true;
    } else {
      return false;
    }
  }
  
  static isHourlyPrice(exception, plan){
    if (plan.has_session_price && exception.has_session_change_price ||
        !plan.has_session_price && exception.has_hourly_change_price) {
      return true;
    } else {
      return false;
    }
  }

  static isStayPrice(exception, plan) {
    if (plan.rent_type == SMConst.RentType.Stay && exception.has_stay_change_price) {
      return true;
    } else {
      return false;
    }
  }

  static exceptionHoursText(exception){
    return (exception.is_all_day) ? '終日' : exception.start_hour + ':00-' + exception.end_hour + ':00';
  }
  
  static exceptionDailyPriceText(exception){
    if (exception.has_session_change_price) {
      return exception.session_price_text+'/'+exception.session_price_unit_text;
    } else {
      return exception.daily_price_text+'/'+exception.daily_price_unit_text;
    }
  }

  static exceptionStayPriceText(exception) {
    return exception.stay_price_text + '/' + exception.stay_price_unit_text;
  }

  static exceptionHourlyPriceText(exception){
    if (exception.has_session_change_price) {
      return exception.session_price_text+'/'+exception.session_price_unit_text;
    } else {
      return exception.hourly_price_text+'/'+exception.hourly_price_unit_text;
    }
  }
  
  static price(exception, plan, selectedCalendar) {
    var price = 0;
    if (exception) {
      if (plan.rent_type == SMConst.RentType.DayTime) {
        if (exception.has_session_change_price) {
          price = exception.session_price_amount;
        } else {
          if (selectedCalendar == SMConst.CalendarType.DailyPrice) {
            price = exception.daily_price_amount;
          } else {
            price = exception.hourly_price_amount;
          }
        }
      } else {
        price = exception.stay_price_amount;
      }
    } else {
      if (plan.rent_type == SMConst.RentType.DayTime) {
        if (plan.has_session_price) {
          price = plan.session_price;
        } else {
          if (selectedCalendar == SMConst.CalendarType.DailyPrice) {
            price = plan.daily_price;
          } else {
            price = plan.hourly_price;
          }
        }
      } else {
        price = plan.stay_price;
      }
    }

    return Math.floor(price);
  }

  static priceText(exception, plan, selectedCalendar) {
    var priceText;
    if (exception) {
      if (exception.has_session_change_price) {
        priceText = exception.session_price_text;
      } else {
        if (selectedCalendar == SMConst.CalendarType.DailyPrice) {
          priceText = exception.daily_price_text;
        } else {
          priceText = exception.hourly_price_text;
        }
      }
    } else {
      if (plan.has_session_price) {
        priceText = plan.session_price_text;
      } else {
        if (selectedCalendar == SMConst.CalendarType.DailyPrice) {
          priceText = plan.daily_price_text;
        } else {
          priceText = plan.hourly_price_text;
        }
      }
    } 

    return priceText;
  }
  
}
export default SMRoomExceptionHelper;


// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMRoomExceptionHelper.js